export enum DesignerToolNames {
  Remove = 'REMOVE',
  BringToFront = 'BRING_TO_FRONT',
  BringForward = 'BRING_FORWARD',
  SendToBack = 'SEND_TO_BACK',
  SendBackward = 'SEND_BACKWARD',
  BackgroundElement = 'BACKGROUND_ELEMENT',
  Text = 'TEXT',
}

export enum DesignerElementTypes {
  Rectangle = 'rectangle',
  Text = 'text',
  Image = 'image',
}
  